module.exports = __webpack_public_path__ + "img/expanding-orange.046b5e66.svg";